<template>
  <v-container grid-list-xl>
    <div class="head-title mb-4">
      <h1 class="display-1">Transfert pour bénéficier du taux de validation</h1>
    </div>
    <v-card>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-select label="Entreprise" :items="companies" v-model="companySelected"></v-select>
          </v-flex>
          <v-flex xs12 sm6>
            <v-select label="Responsable régional" :items="respRegionaux" v-model="respSelected"></v-select>
          </v-flex>
        </v-layout>
        <div class="d-flex justify-center">
          <v-btn color="primary"><v-icon left>input</v-icon>transférer pour taux de validation</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    name: 'TransfertValidation',
    data: () => ({
      companies: ['Entreprise 1', 'Entreprise 2'],
      respRegionaux: ['Agent 1', 'Agent 2'],
      companySelected: '',
      respSelected: ''
    })
  }
</script>

<style scoped>

</style>